import { ltrim, rtrim } from '@/helpers/trimmers'

const urlOrigin = window.location.origin

const urlBase = process.env.BASE_URL

const cleanPathArray = (args) => args
  .map(arg => (arg || '').toString().trim())
  .map(arg => rtrim(ltrim(arg, '/'), '/'))
  .filter(arg => !!arg)

const urlResolve = (...args) => cleanPathArray(args).join('/')

const urlFullPath = (...args) => urlResolve(urlOrigin, urlBase, urlResolve(args))

/** JD: strip base path from redirect callback */
const cleanPathname = (pathname) => {
  console.log('cleanPath', pathname)
  let baseArr = cleanPathArray(urlBase.split('/'))
  let pathArr = cleanPathArray(pathname.split('/'))
  console.log('baseArr', baseArr, 'pathArr', pathArr)
  // TODO: doesn't work if baseArr.length > 1
  let baseStr = baseArr[0]
  
  if (pathArr[0] == baseStr) pathArr.shift()
  console.log('pathArr', pathArr, 'urlResolve', urlResolve(...pathArr))
  return urlResolve(...pathArr)
}

export {
  urlOrigin,
  urlBase,
  urlResolve,
  urlFullPath,
  cleanPathname
}